import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SenderTrips from "../pages/trips/SenderTrips";
import TravelerTrips from "../pages/trips/TravelerTrips";
import FlexyRideDriver from "../pages/trips/FlexyRideDriver";
import FlexyRidePassenger from "../pages/trips/FlexyRidePassenger";
import FlexyRideSeatDetail from "../pages/flexy-ride/FlexyRideSeatDetail";
import FlexyRidePassengerDetail from "../pages/flexy-ride/FlexyRidePassengerDetail";
import FlexyRideMyApplications from "../pages/flexy-ride/MyApplications";
import FlexyRideMyPassengerListings from "../pages/flexy-ride/MyPassengerListings";
import FlexyRideMyRequests from "../pages/flexy-ride/MyRequests";
import FlexyRideMySeatListings from "../pages/flexy-ride/MySeatListings";
import FlexyRideCreatePassenger from "../pages/flexy-ride/CreatePassenger";
import FlexyRideCreateSeat from "../pages/flexy-ride/CreateSeat";
import SeatListingRequests from "../pages/flexy-ride/SeatListingRequests";
import PassengerListingRequests from "../pages/flexy-ride/PassengerListingRequests";
import TripDetail from "../pages/trip-detail/TripDetail";
import ListNewTrip from "../pages/as-traveler/create/ListNewTrip";
import RequestDelivery from "../pages/as-sender/create/RequestDelivery";
import IncomingRequests from "../pages/as-sender/IncomingRequests";
import MyRequests from "../pages/as-sender/MyRequests";
import TravelerTripRequests from "../pages/as-sender/TravelerTripRequests";
import MyListings from "../pages/as-traveler/MyListings";
import TravelerMyRequests from "../pages/as-traveler/MyRequests";
import SenderTripRequests from "../pages/as-traveler/SenderTripRequests";
import LoginPage from "../pages/auth/Login";
import Chat from "../pages/chat/Chat";
import NotificationsPage from "../pages/notifications/Notifications";
import WalletPage from "../pages/wallet/Wallet";
import AddMoneyPage from "../pages/wallet/AddMoney";
import WithdrawMoneyPage from "../pages/wallet/WithdrawMoney";
import AllTransactionsPage from "../pages/wallet/AllTransactions";
import TransactionDetailPage from "../pages/wallet/TransactionDetail";
import DepositAccountPage from "../pages/wallet/DepositAccount";
import WithdrawalAccountPage from "../pages/wallet/WithdrawalAccount";
import StripeConnectReturn from "../pages/wallet/StripeConnectReturn";
import StripeConnectRefresh from "../pages/wallet/StripeConnectRefresh";
import SettingsPage from "../pages/settings/Settings";
import PrivacyPolicyPage from "../pages/settings/PrivacyPolicy";
import TermsOfServicePage from "../pages/settings/TermsOfService";
import ProfilePage from "../pages/profile/Profile";
import EditProfilePage from "../pages/profile/EditProfile";
import ProfileDetailPage from "../pages/profile/ProfileDetail";
import SupportPage from "../pages/profile/Support";
import SupportDetailPage from "../pages/profile/SupportDetail";
import AdminApp from "../adminPages/AdminApp";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/trips/sender",
    element: <SenderTrips />,
  },
  {
    path: "/trips/traveler",
    element: <TravelerTrips />,
  },
  {
    path: "/flexy-ride/driver",
    element: <FlexyRideDriver />,
  },
  {
    path: "/flexy-ride/passenger",
    element: <FlexyRidePassenger />,
  },
  {
    path: "/flexy-ride/seat/:listingId",
    element: <FlexyRideSeatDetail />,
  },
  {
    path: "/flexy-ride/passenger/:listingId",
    element: <FlexyRidePassengerDetail />,
  },
  {
    path: "/flexy-ride/my-applications",
    element: <FlexyRideMyApplications />,
  },
  {
    path: "/flexy-ride/my-passenger-listings",
    element: <FlexyRideMyPassengerListings />,
  },
  {
    path: "/flexy-ride/my-requests",
    element: <FlexyRideMyRequests />,
  },
  {
    path: "/flexy-ride/my-seat-listings",
    element: <FlexyRideMySeatListings />,
  },
  {
    path: "/flexy-ride/create-passenger",
    element: <FlexyRideCreatePassenger />,
  },
  {
    path: "/flexy-ride/create-seat",
    element: <FlexyRideCreateSeat />,
  },
  {
    path: "/flexy-ride/seat-listing-requests/:listingId",
    element: <SeatListingRequests />,
  },
  {
    path: "/flexy-ride/passenger-listing-requests/:listingId",
    element: <PassengerListingRequests />,
  },
  {
    path: "/trips/detail/:tripId",
    element: <TripDetail />,
  },
  {
    path: "/list-new-trip",
    element: <ListNewTrip />,
  },
  {
    path: "/request-delivery",
    element: <RequestDelivery />,
  },
  {
    path: "/incoming-requests",
    element: <IncomingRequests />,
  },
  {
    path: "/trip-requests/:tripId",
    element: <TravelerTripRequests />,
  },
  {
    path: "/my-requests",
    element: <MyRequests />,
  },
  {
    path: "/my-listings",
    element: <MyListings />,
  },
  {
    path: "/traveler/my-requests",
    element: <TravelerMyRequests />,
  },
  {
    path: "/traveler/trip-requests/:tripId",
    element: <SenderTripRequests />,
  },
  {
    path: "/notifications",
    element: <NotificationsPage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  {
    path: "/settings/privacy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/settings/terms",
    element: <TermsOfServicePage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/profile/edit",
    element: <EditProfilePage />,
  },
  {
    path: "/profile/detail/:userId",
    element: <ProfileDetailPage />,
  },
  {
    path: "/profile/support",
    element: <SupportPage />,
  },
  {
    path: "/profile/support/:ticketId",
    element: <SupportDetailPage />,
  },
  {
    path: "/wallet",
    element: <WalletPage />,
  },
  {
    path: "/wallet/add",
    element: <AddMoneyPage />,
  },
  {
    path: "/wallet/withdraw",
    element: <WithdrawMoneyPage />,
  },
  {
    path: "/wallet/all-transactions",
    element: <AllTransactionsPage />,
  },
  {
    path: "/wallet/transactions/:transactionId",
    element: <TransactionDetailPage />,
  },
  {
    path: "/wallet/deposit-account",
    element: <DepositAccountPage />,
  },
  {
    path: "/wallet/withdrawal-account",
    element: <WithdrawalAccountPage />,
  },
  {
    path: "/stripe-connect-return",
    element: <StripeConnectReturn />,
  },
  {
    path: "/stripe-connect-refresh",
    element: <StripeConnectRefresh />,
  },
  {
    path: "/chat",
    element: <Chat />,
  },
  {
    path: "/chat/:conversationId",
    element: <Chat />,
  },
  {
    path: "/admin/*",
    element: <AdminApp />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
